import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from '../../../app/core/services/loading.service';
import { AppConstants } from '../../../config/app-constants';
import { ACCOUNTS_API_ENDPOINTS } from '../../../endpoints.const';
import { Account } from './account.model';

@Injectable({
    providedIn: 'root'
})
export class AccountService {
    // private apiUrl = `${environment.baseAPIUrl}`;
    private apiUrl = AppConstants.APP_BASE_API_URL;

    constructor(public http: HttpClient, public loaderService: LoaderService) { }

    lastVisitedAccount(payload: any): Observable<any> {
        let url = `${AppConstants.APP_BASE_API_URL}${ACCOUNTS_API_ENDPOINTS.SEARCH}`;
        return this.http.post<Account>(url, payload);
    }
}
